<template>
    <div class="container">
        <div class="columns">
            <div class="column">
                <h1 class="title">{{ translate("federation.your_federations") }}</h1>
                <h2 class="subtitle" v-html="translate('federation.description')"></h2>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div>
                    <button class="button is-primary" @click="createFederation">
                        <span class="icon">
                            <i class="fas fa-plus"></i>
                        </span>
                        <span>{{ translate("federation.create_federation") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <p>{{ translate("federation.federations_you_belong_to") }}</p>
            </div>
        </div>

        <div class="columns is-multiline" v-if="initDone && federationStore.userFederations.length > 0">
            <div class="column is-6" v-for="userFederation in federationStore.userFederations" :key="userFederation.id">
                <div class="box is-flex is-flex-direction-screen-based is-flex-align-items-screen-based">
                    <div class="is-flex-grow-1 is-flex is-align-items-center">
                        <figure class="thumbnail-image-container">
                            <img class="thumbnail-image-centered" v-if="userFederation.logoUrl" :src="userFederation.logoUrl" />
                            <img class="thumbnail-image-centered" v-else src="https://martialmatch.com/img/no-image.png" />
                        </figure>

                        <div class="ml-5">
                            <p class="has-text-weight-bold is-size-5">
                                <a :href="urls.federations().manageFederation(userFederation.id)" class="has-text-link">
                                    {{ userFederation.federationName }}
                                </a>
                            </p>
                            <p>
                                <span class="is-description">{{ translate("admin.manage_organizers.role") }}:</span>
                                {{ translateFederationRole(userFederation.federationRole) }}
                            </p>
                        </div>
                    </div>
                    <div class="mt-3-mobile">
                        <a :href="urls.federations().manageFederation(userFederation.id)">
                            <span class="icon">
                                <i class="fas fa-cog"></i>
                            </span>
                            <span>{{ translate("federation.manage_federation") }}</span>
                        </a>
                        <a class="ml-3" :href="urls.federations().manageEventsWithFederation(userFederation.id)">
                            <span class="icon">
                                <i class="fas fa-calendar-alt"></i>
                            </span>
                            <span>{{ translate("federation.view_events") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns" v-else-if="initDone && federationStore.userFederations.length === 0">
            <div class="column">
                <Notification class="is-info">
                    <span class="icon">
                        <i class="fas fa-info-circle"></i>
                    </span>
                    <span>
                        {{ translate("federation.no_federations_found") }}
                    </span>
                </Notification>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useFederationStore } from "./federationStore";
    import { eventBus, OPEN_FEDERATION_CREATE_MODAL } from "../eventBus";
    import { onMounted, ref } from "vue";
    import Notification from "../../Common/Notification.vue";
    import urls from "../../Urls/urls";
    import { translateFederationRole } from "../../Api/federationsApi";
    import { translate } from "../../Common/translations";

    const initDone = ref(false);
    const federationStore = useFederationStore();

    function createFederation() {
        eventBus.$emit(OPEN_FEDERATION_CREATE_MODAL);
    }

    onMounted(() => {
        initDone.value = false;
        return federationStore.fetchFederationsForUser().finally(() => {
            initDone.value = true;
        });
    });
</script>

<style scoped></style>
